import { MessagesTitles, MessagesStatus } from './../../../models/messages';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { RiesgoService } from 'app/services/riesgo/riesgo.service';
import { Chart} from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels';

import Swal from 'sweetalert2';

Chart.plugins.register(ChartDataLabels);

import * as XLSX from 'xlsx';
import { environment } from 'environments/environment';

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};
@Component({
  selector: 'app-listado-cartera-riesgo',
  templateUrl: './listado-cartera-riesgo.component.html',
  styleUrls: ['./listado-cartera-riesgo.component.scss'],
  providers:[MessagesTitles,MessagesStatus]
})
export class ListadoCarteraRiesgoComponent implements OnInit {

  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  Label_id_soles=environment.ID_GUIA_SOLES;
  Label_id_dolares=environment.ID_GUIA_DOLARES;
  displayedColumnsSoles = ['Nombre_Fondo','Monto_Fondo_Disponible','Monto_Fondo_Ejecutado'];
  displayedColumnsDolares = ['Nombre_Fondo','Monto_Fondo_Disponible','Monto_Fondo_Ejecutado'];
  displayedColumnsAdquirenteSoles = ['Num_Doc_Identificacion','Razon_Social','montoFondo'];
  displayedColumnsAdquirenteDolares = ['Num_Doc_Identificacion','Razon_Social','montoFondo'];
  displayedColumnsDetalleFondo = ['Nombre_Sector','Monto_Sector_Fondo','Monto_Sector_Fondo_Bloqueado','Monto_Sector_Fondo_Disponible','Monto_Sector_Fondo_Ejecutado'];
  displayedColumnsDetalleAdquirente = ['idComprobante','Nombre_Fondo','VNPP','Porcentaje_Fondo','Moneda_Descripcion','Fecha_Vencimiento'];

  dataSourceSoles : any;
  dataSourceDolares :any;
  dataSourceDetalleFondo :any;
  dataSourceAdquirenteSoles :any;
  dataSourceAdquirenteDolares :any;
  dataSourceAdquirenteDetalle :any;
  
  @ViewChild('paginatorFondoSoles', {static: false}) paginatorFondoSoles: MatPaginator;
  @ViewChild('paginatorFondoDolares', {static: false}) paginatorFondoDolares: MatPaginator;
  @ViewChild('paginatorAdquirenteSoles', {static: false}) paginatorAdquirenteSoles: MatPaginator;
  @ViewChild('paginatorAdquirenteDolares', {static: false}) paginatorAdquirenteDolares: MatPaginator;
  @ViewChild('paginatorDetalleFondo', {static: false}) paginatorDetalleFondo: MatPaginator;
  @ViewChild('paginatorDetalleAdquirente', {static: false}) paginatorDetalleAdquirente: MatPaginator;

  private sortFondoSoles: MatSort;
  private sortFondoDolares: MatSort;
  private sortAdquirenteSoles: MatSort;
  private sortAdquirenteDolares: MatSort;
  private sortDetalleFondo: MatSort;
  private sortDetalleAdquirente: MatSort;
  
  loading: boolean; 
  isLoading: boolean;
  sector : boolean = false; 
  cartera:any[] = [];
  fondo:any = [];
  fondoP:any = [];
  colors:any = [];
  montoFondo:any = [];
  montoFondoDisponible:any = [];
  fondoSoles:any = [];
  fondoDolares:any = [];
  sectores:any = [];
  popup :boolean=false;
  popupAdquirente :boolean=false;
  listaSectores : any= [];
  porcentaje : any= [];

  montoTotalS = 0;
  montoDisponibleS = 0;
  montoEjecutadoS = 0;
  montoTotalD = 0;
  montoDisponibleD = 0;
  montoEjecutadoD = 0;

  fondonombre : any;
  moneda:any;
  pieChartSectorDolares:any=[];
  pieChartSectorSoles:any=[];
  pieChartFondos:any=[];

  nombreSectorSoles:any=[];
  montoSectorFondoSoles:any=[];
  PorcentajeSectorSoles:any=[];

  nombreSectorDolares:any=[];
  montoSectorFondoDolares:any=[];
  porcentajeSectorDolares:any=[];

  datareporte:any=[];
  
  listadoCAdquirentes: any = [];
  listadoCAdquirentesSoles: any = [];
  listadoCAdquirentesDolares: any = [];
  detalleAdquirente: any = [];
  nombreAdquirente: any = [];

  constructor(private riesgoService:RiesgoService) { }
     
  ngOnInit() {  
    this.ListarFondoGeneral();
    this.ListarSectores();
    this.listadoConcentracionAdquirentes() 
    this.obtenerReportecartera();
  } 
  ExportTOExcel() {
    
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.datareporte);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    let fecha = new Date();
    XLSX.writeFile(wb, 'Reporte_Cartera' + fecha + '.xlsx');
  }

  ListarFondoGeneral(){  
    this.loading  = true;
    this.riesgoService.obtenerFondos().subscribe(
      res=>{      
        this.loading  = false;  
        this.fondo = res;
        for (let item of this.fondo){
          this.fondoP.push(item.Nombre_Fondo)
          this.montoFondo.push(Number(item.Monto_Fondo))
          this.montoFondoDisponible.push(Number(item.Monto_Fondo_Disponible))
       }
      this.crearChartFondo();

      this.fondoSoles = this.fondo.filter(moneda => moneda.Moneda == this.Label_id_soles);
      this.fondoDolares = this.fondo.filter(moneda => moneda.Moneda == this.Label_id_dolares);

      this.dataSourceSoles = new MatTableDataSource(this.fondoSoles)
      this.dataSourceSoles.paginator = this.paginatorFondoSoles;
      this.dataSourceSoles.sort = this.sortFondoSoles;
      
      this.dataSourceDolares = new MatTableDataSource( this.fondoDolares);
      this.dataSourceDolares.sort = this.sortFondoDolares;
      this.dataSourceDolares.paginator = this.paginatorFondoDolares; 

      this.loading = false;
      this.calcularTotalFondo();
      }, err => {
        Swal.fire({
          title: "!Algo salió mal!",
          text: err.error['error'],
          type: "warning",
          allowOutsideClick: true,
          heightAuto: false
        });
        this.isLoading = false;
        this.loading = false
      }
    )  
  }

  ListarSectores(){
    this.loading = true;
    this.riesgoService.listarFinanciamientoSector().subscribe(
      res=>{
      this.listaSectores = res;
      /*chart sector Dolares*/ 
      for (let item of this.listaSectores.fondos_soles){
        this.nombreSectorSoles.push(item.Nombre_Sector)
        this.montoSectorFondoSoles.push(Number(item.Monto_Financiamiento_Sector_Fondo))
        this.PorcentajeSectorSoles.push(Number(item.Porcentaje_Financiamiento_Sector_Fondo))
     }
     this.crearChartSectorSoles();  
      /*chart sector Dolares */
      for (let item of this.listaSectores.fondos_dolares){
        this.nombreSectorDolares.push(item.Nombre_Sector)
        this.montoSectorFondoDolares.push(Number(item.Monto_Financiamiento_Sector_Fondo))
        this.porcentajeSectorDolares.push(Number(item.Porcentaje_Financiamiento_Sector_Fondo))
     }
      this.crearChartSectorDolares();
      this.loading = false;
      },
      () => {
        this.loading = false;
        Swal.fire({
          title: 'Error',
          text: "Sector no obtenido. Contactar con soporte.",
          type: "error",
          allowOutsideClick: true,
          heightAuto: false
        });
      }
    ); 
  }

  listadoConcentracionAdquirentes() {
    this.riesgoService.listarConcentracionAdquirente().subscribe(
      resp => {
        this.listadoCAdquirentes = resp;
        this.listadoCAdquirentesSoles = this.listadoCAdquirentes.adquirientes_soles
        this.listadoCAdquirentesDolares = this.listadoCAdquirentes.adquirientes_dolares
        this.dataSourceAdquirenteSoles = new MatTableDataSource(this.listadoCAdquirentesSoles);
        this.dataSourceAdquirenteSoles.sort = this.sortAdquirenteSoles;
        this.dataSourceAdquirenteSoles.paginator = this.paginatorAdquirenteSoles;
       this.dataSourceAdquirenteDolares = new MatTableDataSource(this.listadoCAdquirentesDolares);
       this.dataSourceAdquirenteDolares.sort = this.sortAdquirenteDolares;
       this.dataSourceAdquirenteDolares.paginator = this.paginatorAdquirenteDolares;
      },
      () => {
        Swal.fire({
          title: 'Error',
          text: "Concentración de adquirentes no obtenido. Contactar con soporte.",
          type: "error",
          allowOutsideClick: true,
          heightAuto: false
        });
      }
    );
  }

    obtenerReportecartera(){
    this.riesgoService.obtenerReporte().subscribe(
      res=>{
      this.datareporte = res;
      console.log('this.datareporte', this.datareporte);
      }
    )
  }

  crearChartFondo(){
    var self = this;
    this.pieChartFondos = new Chart('pieChartFondos', {
      type: 'pie',
    data: {
     labels: this.fondoP,
     datasets: [{
         label: '#',
         data: this.montoFondo,
         backgroundColor: ["#0074D9", "#FF4136", "#2ECC40", "#FF851B", "#7FDBFF", "#B10DC9", "#FFDC00", "#001f3f", "#39CCCC",
         "#01FF70", "#85144b", "#F012BE", "#3D9970", "#111111", "#AAAAAA","#f38b4a","#56d798","#ff8397","#6970d5","#FF86BA",
         "#A3940D","#058AA3","#944E6D","#BD6500"],
         hoverBackgroundColor: this.colors,
         borderWidth: 1
        },
       ]
    }, 
    options: {
      responsive : true,
      plugins: {
        datalabels: {
            color: 'white',
            anchor: "center",
            align: "end",
            font: {
                weight: 'bold'
            },
          formatter: (value, ctx) => {
             var sum = self.montoFondo.reduce(function(a, b){ return a + b; });
            return (value*100 / sum).toFixed(2)+"%";
        },
        }
    }
    },
    
    }); 
  this.pieChartFondos.update();
  }

  crearChartSectorSoles(){
    var self = this;
    this.pieChartSectorSoles = new Chart('pieChartSectorSoles', {
      type: 'bar',
    data: {
     labels: this.nombreSectorSoles,
     datasets: [{
         label: 'Total',
         data: this.montoSectorFondoSoles,
        backgroundColor: ["#0074D9", "#FF4136", "#2ECC40", "#FF851B", "#7FDBFF", "#B10DC9", "#FFDC00", "#001f3f", "#39CCCC",
         "#01FF70", "#85144b", "#F012BE", "#3D9970", "#111111", "#AAAAAA","#f38b4a","#56d798","#ff8397","#6970d5","#FF86BA",
         "#A3940D","#058AA3","#944E6D","#BD6500"],
         borderWidth: 1
     }]
    }, 
    options: {
      responsive : true,
      plugins: {
        datalabels: {
            color: 'green',
            anchor: "end",
            align: "end",
            font: {
                weight: 'bold'
            },
            formatter: function(value,context){
              return self.PorcentajeSectorSoles[context.dataIndex]+ " %";
          }

        }
    }
    }
    }); 
  }

  crearChartSectorDolares(){
    var self = this;
    this.pieChartSectorDolares = new Chart('pieChartSectorDolares', {
      type: 'bar',
    data: {
     labels: this.nombreSectorDolares,
     datasets: [{
         label: 'Total',
         data: this.montoSectorFondoDolares,
         backgroundColor: [ "#001f3f", "#AAAAAA","#f38b4a","#56d798","#ff8397","#6970d5","#FF86BA",
         "#A3940D","#058AA3","#944E6D","#BD6500","#0074D9", "#FF4136", "#2ECC40", "#FF851B", "#7FDBFF", "#B10DC9", "#FFDC00", "#001f3f", "#39CCCC","#01FF70", "#F012BE", "#3D9970", "#111111"],
         borderWidth: 1
     }]
    }, 
    options: {
      scales: {
        xAxes: [{
          stacked: true,
        }],
        yAxes: [{
          stacked: true
        }]
      },
      plugins: {
        datalabels: {
            color: 'green',
            anchor: "end",
            align: "end",
            font: {
                weight: 'bold'
            },
            formatter: function(value,context){
              return self.porcentajeSectorDolares[context.dataIndex]+ " %";
          }

        }
    }
    },
    });
  }

  
  calcularTotalFondo(){
    this.montoTotalS = 0;
    this.montoDisponibleS = 0;
    this.montoEjecutadoS = 0;
    this.montoTotalD = 0;
    this.montoDisponibleD = 0;
    this.montoEjecutadoD = 0;
    for (let item of this.fondo){
       if (item.Moneda == this.Label_id_soles) {
        this.montoTotalS = Math.round((Number(item.Monto_Fondo)+Number(this.montoTotalS))*100)/100;
        this.montoDisponibleS = Math.round((Number(item.Monto_Fondo_Disponible)+Number(this.montoDisponibleS))*100)/100;
        this.montoEjecutadoS = Math.round((Number(item.Monto_Fondo_Ejecutado)+Number(this.montoEjecutadoS))*100)/100;
       }else if (item.Moneda == this.Label_id_dolares){
        this.montoTotalD = Math.round((Number(item.Monto_Fondo)+Number(this.montoTotalD))*100)/100;
        this.montoDisponibleD = Math.round((Number(item.Monto_Fondo_Disponible)+Number(this.montoDisponibleD))*100)/100;
        this.montoEjecutadoD = Math.round((Number(item.Monto_Fondo_Ejecutado)+Number(this.montoEjecutadoD))*100)/100;
       }
    } 
}

  /*Fondo en Moneda*/

  getTotalSolesDisponible() {
    return this.fondoSoles.map(t => t.Monto_Fondo_Disponible).reduce((acc, value) => Number(acc) + Number(value), 0);
  }

  getTotalSolesEjecutado() {
    return this.fondoSoles.map(t => t.Monto_Fondo_Ejecutado).reduce((acc, value) => Number(acc) + Number(value), 0);
  }

  getTotalDolaresDisponible() {
    return this.fondoDolares.map(t => t.Monto_Fondo_Disponible).reduce((acc, value) => Number(acc) + Number(value), 0);
  }

  getTotalDolaresEjecutado() {
    return this.fondoDolares.map(t => t.Monto_Fondo_Ejecutado).reduce((acc, value) => Number(acc) + Number(value), 0);
  }

  /*Detalle Fondo - sector*/
  getTotalSectorTotal() {
    return this.sectores.map(t => t.Monto_Sector_Fondo).reduce((acc, value) => Number(acc) + Number(value), 0);
  }

  getTotalSectorBloqueado() {
    return this.sectores.map(t => t.Monto_Sector_Fondo_Bloqueado).reduce((acc, value) => Number(acc) + Number(value), 0);
  }

  getTotalSectorDisponible() {
    return this.sectores.map(t => t.Monto_Sector_Fondo_Disponible).reduce((acc, value) => Number(acc) + Number(value), 0);
  }

  getTotalSectorEjecutado() {
    return this.sectores.map(t => t.Monto_Sector_Fondo_Ejecutado).reduce((acc, value) => Number(acc) + Number(value), 0);
  }

  /*Concentración Adquirente*/
  getTotalSolesAdquirente(){
    return this.listadoCAdquirentesSoles.map(t => t.montoFondo).reduce((acc, value) => Number(acc) + Number(value), 0);
  }

  getTotalDolaresAdquirente(){
    return this.listadoCAdquirentesDolares.map(t => t.montoFondo).reduce((acc, value) => Number(acc) + Number(value), 0);
  }
  /*detalle Adquirente*/
  getTotalVnppDetalleAdquirente(){
    return this.detalleAdquirente.map(t => t.VNPP).reduce((acc, value) => Number(acc) + Number(value), 0);
  }
  
  /*popUpSector*/
  Sector(row:any, moneda){
    this.fondonombre=row.Nombre_Fondo
    this.moneda = moneda;
    this.sectores = row.sectores_fondo
    this.dataSourceDetalleFondo = new MatTableDataSource( this.sectores);
    this.dataSourceDetalleFondo.sort = this.sortDetalleFondo;
    this.dataSourceDetalleFondo.paginator = this.paginatorDetalleFondo;
    this.popup=true;
  }
  /*popUpAdquirente*/
  verDetalleAdquirente(row:any){
    this.loading=true;
    this.riesgoService.VerConcentracionAdquirente(row).subscribe(
      res=>{
      this.loading=false;
      this.detalleAdquirente = res;
      this.nombreAdquirente = this.detalleAdquirente[0].Razon_Social;
      this.dataSourceAdquirenteDetalle = new MatTableDataSource( this.detalleAdquirente);
      this.dataSourceAdquirenteDetalle.sort = this.sortDetalleAdquirente;
      this.dataSourceAdquirenteDetalle.paginator = this.paginatorDetalleAdquirente;
      },
      () => {
        this.loading = false;
        Swal.fire({
          title: 'Error',
          text: "Detalle no obtenido. Contactar con soporte.",
          type: "error",
          allowOutsideClick: true,
          heightAuto: false
        });
      }
    ) 
    this.popupAdquirente=true;
  }

  cerrarPopup(){
    this.sectores=[];
    this.popup=false;
  }
  cerrarPopupAdquirente(){
    this.detalleAdquirente=[];
    this.popupAdquirente=false;
  }


}
